import React, { useState, useEffect } from "react";
import { PageHeader } from "components/ui";
import {
  Grid,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import StandardsSelector from "components/customizedStandardsComponent/GriStandardsSelector";
import NavigationButtons from "helper/navigation/NavigationButtons";
import {
  ESG_AUTO_SYNCED_SUSTAIN_DASHBOARD,
  ENVIRONMENTAL_MONITORING_Synchronized,
} from "data/standards/griStandards";
import ReportsReviewDialog from "components/customizedStandardsComponent/ReportsReviewDialog";
import { useLocation, useNavigate } from "react-router-dom";
import DownloadReport from "components/customizedStandardsComponent/DownloadReport";
import {} from "data/reports/relevantReports";
import ReusableFormComponent from "components/customizedStandardsComponent/EsgFormComponent";
import {
  DIGITAL_OBSERVATION_CAPTURE_AND_REPORTING,
  FIELD_OBSERVATION_TEMPLATE,
  ENVIRONMENTAL_MONITORING_FORM,
  NOISE_MONITORING_FORM,
  Noise_Monitoring_Report,
  NOISE_SYNC_ESG_DASHBOARD,
  Digital_PTW_PPE_Step_1,
  Smart_PTW_PPE_Compliance_Step_2,
  Smart_PTW_PPE_Compliance_Step_3,
} from "data/forms/griFormSchema";
import SmartTemplate from "components/customizedStandardsComponent/SmartTemplate";
import { ENVIRONMENTAL_MONITORING_AI_TEMPLATES } from "data/templates/smartTemplateData";

const PermitAndPPEChecks = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [prevStep, setPrevStep] = useState(0);
  const locationData = useLocation();
  const navigationRoute = useNavigate();
  const [showReviewPopup, setShowReviewPopup] = useState(false);
  const [reportData, setReportData] = useState({
    selectedStandards: [],
    companyInfo: {},
  });

  const steps = ["d", "d", "d"];

  const handleNext = () => {
    setPrevStep(activeStep);
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const HandleNavigation = () => {
    console.log("checkssConstant", locationData);
    navigationRoute(locationData?.state?.route || locationData.pathname);
  };

  const handleBack = () => {
    setPrevStep(activeStep);
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleClosePopup = () => {
    setShowReviewPopup(false);
  };

  const handleSkipToStep5 = () => {
    setPrevStep(activeStep);
    setActiveStep(5);
    setShowReviewPopup(false);
  };

  const handleSaveStandards = (selectedStandards) => {
    setReportData((prev) => ({
      ...prev,
      selectedStandards,
    }));
    console.log("Standards saved:", selectedStandards);
  };

  const handleBackFromStandardsSelector = (
    selectedStandards,
    activityDetails
  ) => {
    if (selectedStandards && selectedStandards.length > 0) {
      setReportData((prev) => ({
        ...prev,
        selectedStandards,
      }));
    }
    handleBack();
  };

  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <SmartTemplate
            {...Digital_PTW_PPE_Step_1}
            onNext={handleNext}
            onPrevious={handleBack}
            showPreviousButton={true}
            showDownloadButton={false}
            extraBottomActions={Digital_PTW_PPE_Step_1.extraBottomActions}
          />
        );
      case 1:
        return (
          <SmartTemplate
            {...Smart_PTW_PPE_Compliance_Step_2}
            onNext={handleNext}
            onPrevious={handleBack}
            showPreviousButton={true}
            nextButtonText="Sync with ESG Dashboard"
            showReportCountdownButton={true}
            downloadButtonTitle="Download PTW Compliance Log"
          />
        );
      case 2:
        return (
          <StandardsSelector
            standards={Smart_PTW_PPE_Compliance_Step_3}
            title="Auto-Synced to ESG Vision Dashboard	"
            nextButtonText="Save & Continue →"
            showSaveButton={true}
            showReportCountdownButton={true}
            onNext={(selected) => {
              console.log("Selected ESG Standards:", selected);
            }}
            onBack={handleBackFromStandardsSelector}
            showBackButton={true}
            showNextButton={false}
          />
        );
      default:
        return "Unknown step";
    }
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <PageHeader title="AI-Powered ESG Reporting across Global, National, Sectoral, and Industry-Specific Standards" />
          </Box>
          <Grid item xs={12}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <NavigationButtons
                imageKey="dashboardImg7_1"
                title={locationData?.state?.label || ""}
                activeStep={activeStep}
                onBack={handleBack}
              />
            </Box>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          {getStepContent(activeStep)}
        </Grid>

        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mt: 4,
              mb: 2,
            }}
          ></Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: -1,
            }}
          >
            {steps.map((_, index) => (
              <Box
                key={index}
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  backgroundColor: index <= activeStep ? "#02462E" : "#e0e0e0",
                  mx: 1,
                }}
              />
            ))}
          </Box>
        </Grid>
      </Grid>

      <ReportsReviewDialog
        open={showReviewPopup}
        onClose={handleClosePopup}
        onSkip={handleSkipToStep5}
      />
    </>
  );
};

export default PermitAndPPEChecks;
